import React, { useState, useContext, useEffect } from 'react';
import styles from './CreateUser.module.scss';
import { useHistory } from 'react-router-dom';
import { CreateUserForm, PermissionsForm } from './components';
import {
	Header,
	PageContainer,
	Sidebar,
	SideMenu,
	Page,
	PageAuth,
	PageHeader,
	Breadcrumbs,
	GlobalAlert,
	PERMISSIONS,
} from '../..';
import { adminPages, BACKOFFICE_USERS_URL, CREATE_USER_URL, useStore } from '../../../common';
import { AuthContext } from '../../../logic';
import { Button, CloseDark } from 'esa-ui-library';

const CreateUser = (): JSX.Element => {
	const [permissions, setPermissions] = useState(false);
	const [, dispatch] = useStore(false);
	const history = useHistory();
	const { user, token } = useContext(AuthContext);

	useEffect(() => {
		dispatch('USER_INIT', user);
	}, []);

	const onPageDiscard = () => {
		history.goBack();
	};

	const onUserSubmit = () => {
		dispatch('USER_SUBMIT', { token, history });
	};

	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canCreateUser}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={adminPages} title='Admin' />
					</Sidebar>
					<Page>
						<PageHeader>
							<Breadcrumbs pages={[BACKOFFICE_USERS_URL, CREATE_USER_URL]} />
							<Button small onClick={onPageDiscard} dataId='discard-button'>
								<CloseDark className={styles.Discard} /> Discard
							</Button>
						</PageHeader>
						<section className={styles.PageContent}>
							{!permissions && <CreateUserForm onSubmit={() => setPermissions(true)} />}
							{permissions && <PermissionsForm onBack={() => setPermissions(false)} onSubmit={onUserSubmit} />}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { CreateUser };
